import _ from 'lodash'
import React from 'react'
import classnames from 'classnames'
import { styled } from '@mui/styles'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

import styles from './styles'

const CustomButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.lighter,
  backgroundColor: theme.palette.primary.main,

  '&:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}))

export default ({
  children,
  className,
  fontSize,
  loadingSize,
  color = 'primary',
  disabled,
  fullWidth = false,
  loading,
  onClick = () => {},
  type,
  startIcon = null,
  variant = 'contained',
}) => {
  const classes = styles()

  const onClickDebounce = _.debounce(onClick, 1000, {
    leading: true,
    trailing: false,
  })

  const renderChildren = () => {
    if (_.isString(children) && !startIcon) return <strong>{children}</strong>

    return children
  }

  return (
    <CustomButton
      style={{ fontSize: fontSize }}
      className={classnames(classes.button, className)}
      color={color}
      disabled={disabled || loading}
      disableElevation={true}
      fullWidth={fullWidth}
      startIcon={startIcon}
      onClick={
        !disabled && !loading && _.isFunction(onClick) ? onClickDebounce : null
      }
      type={type}
      variant={variant}
    >
      {loading ? <CircularProgress size={loadingSize}/> : renderChildren()}
    </CustomButton>
  )
}
